import { differenceInCalendarDays, max } from "./date-fns.utils";
import { addWeekdays } from "./date.utils";
var NOW = new Date();
export var getSepaLatestApprovalDate = function (paymentRequest, offset) {
    if (offset === void 0) { offset = 3; }
    var dueDateOrNow = max([NOW, paymentRequest.dueDateAt]);
    var result = addWeekdays(dueDateOrNow, -offset);
    while (differenceInCalendarDays(result, NOW) < 0) {
        result = addWeekdays(result, 1);
    }
    return result;
};
export var getSepaDueDate = function (paymentRequest, offset) {
    if (offset === void 0) { offset = 3; }
    return addWeekdays(getSepaLatestApprovalDate(paymentRequest, offset), offset);
};
